export default "__VITE_ASSET__crmlXtef__"